import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=69c1d981&scoped=true"
import script from "./ordersList.vue?vue&type=script&lang=js"
export * from "./ordersList.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/order/dialog-bonus.scss?vue&type=style&index=0&lang=scss&external"
import style1 from "./ordersList.vue?vue&type=style&index=1&id=69c1d981&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c1d981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c1d981')) {
      api.createRecord('69c1d981', component.options)
    } else {
      api.reload('69c1d981', component.options)
    }
    module.hot.accept("./ordersList.vue?vue&type=template&id=69c1d981&scoped=true", function () {
      api.rerender('69c1d981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/ordersList.vue"
export default component.exports